import WhatsappIcon from 'assets/svg/whatsapp/whatsapp.svg'
import Button from 'common/components/Button'
import Typography from 'common/components/Typography'
import { WHATSAPP_URL } from 'common/constants'
import theme from 'common/theme'
import { mediaflexCdn } from 'lib/cdn'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Section = styled.section`
  display: flex;
  justify-content: center;
  padding: 60px 24px;
`

const Card = styled.div`
  width: ${theme.layout.containerWidth};
  max-width: 1180px;
  border-radius: 36px;
  overflow: hidden;
  position: relative;
  color: ${theme.colors.white};
  padding: 40px;
  background-image: url(${mediaflexCdn(
    '/f=auto,w=1920/assets/img/background-cta.png',
  )});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 32px;
    text-align: center;
    align-items: center;
  }
`

const Title = styled(Typography)`
  font-size: 34px;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  color: ${theme.colors.white};
  max-width: 450px;
`

const CTAButton = styled(Button)`
  border-radius: 999px;
  padding: 12px 24px;
  font-weight: 600;
  background-color: ${theme.colors.green};
  color: ${theme.colors.white};
  transition: background-color 0.3s ease;
  item-align: center;
  display: flex;
  gap: 8px;

  &:hover {
    background-color: ${theme.colors.greenDark};
  }
`

const CallToActionSection = (): JSX.Element => {
  const { t } = useTranslation('home')

  return (
    <Section data-testid="cta-section">
      <Card>
        <Title type="bh1">{t('CTA_TITLE')}</Title>
        <CTAButton
          as="a"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
        >
          <>
            <WhatsappIcon width="20" fill={theme.colors.white} />
            {t('CTA_WHATSAPP')}
          </>
        </CTAButton>
      </Card>
    </Section>
  )
}

export default CallToActionSection
